import { MEMBERSHIP_AGREEMENT, type AgreementSection } from '@shared/content/membershipAgreement';

/* `as const` metni dar birleşim tipleri üretiyor; çizim için ortak şekil yeter. */
const SECTIONS: readonly AgreementSection[] = MEMBERSHIP_AGREEMENT.sections;

/**
 * Üyelik sözleşmesinin metni — imza ekranı ve Profilim'deki "sözleşmeyi oku"
 * penceresi aynı çizimi kullanır; üye imzaladığı metni birebir yeniden okur.
 *
 * Metin tek dilde (Türkçe): stüdyonun hukuki metnidir, çevirisi imzalanan
 * metin olmazdı. Yazım olduğu gibi korunur (bkz. `membershipAgreement.ts`).
 */
export function AgreementText() {
  return (
    <article lang="tr" className="space-y-6 text-body leading-relaxed text-ink-2">
      <h2 className="text-center font-serif text-lg font-semibold text-ink">
        {MEMBERSHIP_AGREEMENT.title}
      </h2>

      {SECTIONS.map((section, sectionIndex) => {
        const items = section.items.map((item) => (
          <li key={item.text} className="pl-1">
            {item.text}
            {item.subItems !== undefined && (
              <ol className="mt-2 list-[lower-alpha] space-y-1 pl-6">
                {item.subItems.map((sub) => (
                  <li key={sub}>{sub}</li>
                ))}
              </ol>
            )}
          </li>
        ));

        return (
          <section key={section.heading ?? `section-${String(sectionIndex)}`} className="space-y-3">
            {section.heading !== undefined && (
              <h3 className="text-label font-semibold uppercase tracking-wider text-ink">
                {section.heading}
              </h3>
            )}
            {section.ordered ? (
              <ol start={section.start ?? 1} className="list-decimal space-y-2 pl-6">
                {items}
              </ol>
            ) : (
              <ul className="list-disc space-y-2 pl-6">{items}</ul>
            )}
          </section>
        );
      })}

      <p className="border-t border-line pt-4 text-micro font-semibold uppercase tracking-wider text-ink-3">
        {MEMBERSHIP_AGREEMENT.signatureLabel}
      </p>
    </article>
  );
}
